import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-input-checkbox',
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './input-checkbox.html',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputCheckbox),
      multi: true,
    },
  ],
})
export class InputCheckbox implements ControlValueAccessor {
  @Input() label: string = '';
  value: boolean = false;
  onChange: any = () => {};
  onTouched: any = () => {};

  onInputChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.value = isChecked;
    this.onChange(isChecked);
  }

  writeValue(val: boolean): void {
    this.value = val || false;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
